var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"container-card el-row"},[_c('div',[_c('TrackDataCard'),_c('TerritorialCard'),_c('CategoryDataCard'),_c('TopVideosCard'),_c('TopTracksCard'),_c('TopChannelsCard')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }